import { render, staticRenderFns } from "./slideStockIndex.vue?vue&type=template&id=21076a89&scoped=true"
import script from "./slideStockIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./slideStockIndex.vue?vue&type=script&setup=true&lang=js"
import style0 from "./slideStockIndex.vue?vue&type=style&index=0&id=21076a89&prod&lang=less"
import style1 from "./slideStockIndex.vue?vue&type=style&index=1&id=21076a89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21076a89",
  null
  
)

export default component.exports